import { useState, useEffect, useCallback } from 'react';
import { useCategoryService, Category } from '../services/categoryService';

export const useSubAssemblyPoolFolders = (enabled: boolean) => {
  const [folders, setFolders] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { getSubAssemblyPoolFolders } = useCategoryService();

  const loadFolders = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getSubAssemblyPoolFolders();
      setFolders(data ?? []);
      if (!data) setError('Failed to load sub-assembly pool folders');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, [getSubAssemblyPoolFolders]);

  useEffect(() => {
    if (enabled) {
      loadFolders();
    } else {
      setFolders([]);
    }
  }, [enabled, loadFolders]);

  return { folders, loading, error };
};
